var _a;
import { __decorate, __metadata, __param } from "tslib";
import { I18nService } from '@/services/i18n-service';
import { inject, injectable } from 'inversify';
let EditCustomFieldActionContribution = class EditCustomFieldActionContribution {
    constructor(_i18nService) {
        this._i18nService = _i18nService;
    }
    registerCustomFieldActions(action) {
        action.registerCustomFieldAction({
            commandId: 'custom-field.edit',
            icon: 'SolidEdit',
            label: this._i18nService.t('global.btn.edit'),
            order: 1,
            isEnabled: (context) => {
                if (context.isPublicMode) {
                    return context.isAdmin || context.fields[0].create_by_me;
                }
                return true;
            },
            isVisible: (context) => {
                if (context.isPublicMode) {
                    return context.isAdmin || context.fields[0].create_by_me;
                }
                return context.fields.length === 1;
            },
        });
    }
};
EditCustomFieldActionContribution = __decorate([
    injectable(),
    __param(0, inject(I18nService)),
    __metadata("design:paramtypes", [typeof (_a = typeof I18nService !== "undefined" && I18nService) === "function" ? _a : Object])
], EditCustomFieldActionContribution);
export { EditCustomFieldActionContribution };
